import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Box, TextField, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import { Button, Grid } from '@mui/joy';

const validationSchema = yup.object({
    fName: yup.string().required(),
    lName: yup.string().required(),
    tagline:yup.string().required(),
    address:yup.string().required(),
    city:yup.string().required(),
    zip:yup.string().required(),
});

const FundiProfileSetting = () => {
    const formik = useFormik({
        initialValues: {
            fName: '',
            lName: '',
            tagline: '',
            address: '',
            city: '',
            zip: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            alert(JSON.stringify(values, null, 2));
        },
    });

    return (
        <Box>
            <form onSubmit={formik.handleSubmit}>

                <Grid container spacing={2}>

                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ mb: 2 }}>
                            <FormLabel>First Name</FormLabel>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Your First Name"
                                value={formik.values.fName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="fName"
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ mb: 2 }}>
                            <FormLabel>Last Name</FormLabel>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Enter Your Last Name"
                                value={formik.values.lName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="lName"
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box sx={{ mb: 2 }}>
                    <FormLabel>Your Tagline</FormLabel>
                    <TextField
                        fullWidth

                        variant="outlined"
                        placeholder="Enter Your Tagline"
                        value={formik.values.tagline}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="tagline"
                        required
                    />
                </Box>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h5" color="#666666">Location</Typography>
                    <FormLabel>Address Line </FormLabel>
                    <Select

                        value={formik.values.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="country"
                        fullWidth
                    >
                        <MenuItem value="USA">USA</MenuItem>
                        <MenuItem value="Canada">Canada</MenuItem>
                        <MenuItem value="India">India</MenuItem>
                        <MenuItem value="Australia">Australia</MenuItem>
                    </Select>
                </Box>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ mb: 2 }}>
                            <FormLabel>City</FormLabel>
                            <TextField
                                fullWidth

                                variant="outlined"
                                placeholder="Select a City"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="city"
                                required
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6}>
                        <Box sx={{ mb: 2 }}>
                            <FormLabel>Zip</FormLabel>
                            <TextField
                                fullWidth

                                variant="outlined"
                                placeholder="Enter Your Zip Code"
                                value={formik.values.zip}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="zip"
                                required
                            />
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ display: 'flex', justifyItems: 'flex-end', justifyContent: 'end' }}>
                    <Button
                        sx={{
                            backgroundColor: "#28A745",
                            width: "200px",
                            height: "36px",
                            marginBottom: '20px',
                            color: "#fff",
                            border: "0.5px solid #28A745",
                            fontSize: "16px",
                            fontWeight: 500,
                            borderRadius: "6px",
                            lineHeight: "19.5px",
                            "&:hover": {
                                backgroundColor: "#28A745",
                                color: "#fff", boxShadow: 3,
                            }
                        }}
                    >
                        Save & Update
                    </Button>
                </Box>
            </form>
        </Box>
    );
};

export default FundiProfileSetting;
